import ConversationsExportAPI from 'dashboard/api/conversationsExport';

export default {
  namespaced: true,

  actions: {
    export(_, payload) {
      return ConversationsExportAPI.export(payload);
    },
    exportWithFilters(_, payload) {
      return ConversationsExportAPI.exportWithFilters(payload);
    },
  },
};
